import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }

import { onMounted, reactive, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { message } from 'ant-design-vue';
import { finishTask } from "@/api/home";
import uploadFile from "@/components/view/UploadFile.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 't25',
  setup(__props) {

const route = useRoute();
const router = useRouter();


const fileList = ref<any[]>([]);

let orderInfo = reactive({
  patientId: route.query.patientId,
  diagnosisOrderId: route.query.diagnosisOrderId,
  path: '',
});
onMounted(() => {
  const path = `/${orderInfo.patientId}/6/${orderInfo.diagnosisOrderId}/origin/stl`;
  orderInfo.path = path;
})

const finishTaskT25 = () => {
  let processDefinitionId = route.query.processDefinitionId;
  let processInstanceId = route.query.processInstanceId;
  let processDefinitionKey = route.query.processDefinitionKey;
  let runTimeTaskId = route.query.runTimeTaskId;
  let taskCode = route.query.taskCode

  let parameters = {
    processDefinitionId: processDefinitionId,
    processInstanceId: processInstanceId,
    processDefinitionKey: processDefinitionKey,
    runTimeTaskId: runTimeTaskId,
    taskCode: taskCode,
    params: {
      patientId: route.query.patientId,
      diagnosisOrderId: route.query.diagnosisOrderId,
      path: orderInfo.path,
      cnt: fileList.value.length
    }
  };

  finishTask(parameters).then(() => {
    message.success("操作成功");
    router.push({
      path: "/home",
    });
  });
}

const onSuccess = (url: string, index: number) => {
  if (!fileList.value.includes(index)) {
    fileList.value.push(index)
  }
}


return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_space, { direction: "vertical" }, {
      default: _withCtx(() => [
        _createVNode(uploadFile, {
          bnTitle: "上颌",
          fileName: "u.stl",
          accept: ".stl",
          path: _unref(orderInfo).path + '/u.stl',
          onOnSuccess: _cache[0] || (_cache[0] = (url) => onSuccess(url, 1))
        }, null, 8, ["path"]),
        _createVNode(uploadFile, {
          bnTitle: "下颌",
          fileName: "l.stl",
          accept: ".stl",
          path: _unref(orderInfo).path + '/l.stl',
          onOnSuccess: _cache[1] || (_cache[1] = (url) => onSuccess(url, 2))
        }, null, 8, ["path"]),
        (fileList.value.length > 1)
          ? (_openBlock(), _createBlock(_component_a_button, {
              key: 0,
              onClick: finishTaskT25
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 完成任务")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})